export const alternatives = {
  "Carports": {},
  "Divers": {},
  "Overkappingen": {},
  "Poolhouse": {},
  "Tuinhuizen": {}
}